import { render, staticRenderFns } from "./ProdExecPolTypeGrp.vue?vue&type=template&id=5d604f30&"
import script from "./ProdExecPolTypeGrp.vue?vue&type=script&lang=js&"
export * from "./ProdExecPolTypeGrp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports